import { ApolloLink, Observable } from '@apollo/client';
import * as opentelemetryFe from 'opentelemetry-fe';
const {
  context,
  trace,
  SpanStatusCode
} = opentelemetryFe;
function getOperationType(operation) {
  const def = operation.query.definitions.find(d => d.kind === 'OperationDefinition');
  return def && 'operation' in def ? def.operation : 'unknown';
}
export default new ApolloLink((operation, forward) => {
  const tracer = opentelemetryFe.getSafeTracer('apollo-stack-hubspot');
  const operationType = getOperationType(operation);
  const spanName = operation.operationName ? `${operationType} ${operation.operationName}` : operationType;
  const attributes = {
    'graphql.operation.type': operationType,
    'db.system': 'graphql',
    'graphql.hub.cache_hit': false
  };
  if (operation.operationName) {
    attributes['graphql.operation.name'] = operation.operationName;
    attributes['db.operation.name'] = operation.operationName;
  }
  const span = tracer.startSpan(spanName, {
    attributes
  });
  return new Observable(observer => {
    let sub;
    let spanEnded = false;
    const endSpan = () => {
      if (!spanEnded) {
        spanEnded = true;
        span.end();
      }
    };
    context.with(trace.setSpan(context.active(), span), () => {
      sub = forward(operation).subscribe({
        next(result) {
          var _result$errors;
          const ctx = operation.getContext();
          if (ctx.correlationId) {
            span.setAttribute('graphql.hub.correlation_id', ctx.correlationId);
          }
          if ((_result$errors = result.errors) !== null && _result$errors !== void 0 && _result$errors.length) {
            for (const err of result.errors) {
              var _err$extensions;
              span.addEvent('graphql.error', Object.assign({
                'error.message': err.message
              }, (_err$extensions = err.extensions) !== null && _err$extensions !== void 0 && _err$extensions.errorType ? {
                'error.type': String(err.extensions.errorType)
              } : {}));
            }
          }
          span.setStatus({
            code: SpanStatusCode.OK
          });
          endSpan();
          observer.next(result);
        },
        error(err) {
          const {
            correlationId
          } = operation.getContext();
          if (correlationId) {
            span.setAttribute('graphql.hub.correlation_id', correlationId);
          }
          span.recordException(err);
          span.setStatus({
            code: SpanStatusCode.ERROR
          });
          endSpan();
          observer.error(err);
        },
        complete() {
          endSpan();
          observer.complete();
        }
      });
    });
    return () => {
      var _sub;
      (_sub = sub) === null || _sub === void 0 || _sub.unsubscribe();
      endSpan();
    };
  });
});